import {SalesRepReportContext} from '../context'
import {KTCard} from '../../../_metronic/helpers'
import SalesRepReportTable from '../sections/table/SalesRepReportTable'
import useGetSalesRepReport from '../hooks/useGetSalesRepReport'
import {SalesRepReportHeader} from '../sections/header/SalesRepReportsHeader'
import useGetSalesRepTypeDropdown from '../hooks/useGetSalesRepTypeDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'

function SalesRepReport() {
  const {
    reportData: salesRepData,
    isLoading: isSalesRepLoading,
    filters: salesRepFilters,
    onSearch: onSalesRepSearch,
    onSortingChange: onSalesRepSortingChange,
    handleSalesRepReportDateChange,
    onChangeSalesRepTypeFilter,
  } = useGetSalesRepReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('sales_rep')

  const {salesRepTypes, isLoading: isSalesRepDropdownLoading} = useGetSalesRepTypeDropdown()

  const contextValue = {
    salesRepData,
    isSalesRepLoading,
    salesRepFilters,
    onSalesRepSearch,
    onSalesRepSortingChange,
    handleSalesRepReportDateChange,
    onChangeSalesRepTypeFilter,

    salesRepTypes,
    isSalesRepDropdownLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  }

  return (
    <KTCard>
      <SalesRepReportContext.Provider value={contextValue}>
        <SalesRepReportHeader />
        <SalesRepReportTable />
      </SalesRepReportContext.Provider>
    </KTCard>
  )
}

export default SalesRepReport
